import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import { Message } from "element-ui";
import { hasPermission } from "../utils/permission";
import { crmPages } from "./pages";
import CrmShell from "./CrmShell.vue";
import CrmLogin from "./CrmLogin.vue";

Vue.use(VueRouter);

export function firstAccessibleCrmPath() {
  const page = crmPages.find((item) => hasPermission(item.permission));
  return page ? page.path : "";
}

const router = new VueRouter({ routes: [
  { path: "/login", component: CrmLogin, meta: { public: true } },
  { path: "/crm", component: CrmShell, children: crmPages.map((page) => ({
    path: page.path, name: page.title, component: page.component,
    meta: { permission: page.permission },
  })) },
  { path: "*", redirect: "/crm/overview" },
] });

router.beforeEach((to, from, next) => {
  if (to.meta.public) return next();
  if (!store.getters.GET_TOKEN) return next({ path: "/login", query: { redirect: to.fullPath } });
  const landing = firstAccessibleCrmPath();
  if (!landing || !hasPermission("crm.menu")) {
    Message.error("当前账号没有 CRM 使用权限");
    return next("/login");
  }
  if (to.path === "/crm" || (to.path === "/crm/overview" && !hasPermission("crm.overview.view"))) return next(landing);
  if (to.meta.permission && !hasPermission(to.meta.permission)) {
    Message.warning("暂无访问权限");
    return next(landing === to.path ? "/login" : landing);
  }
  next();
});

export default router;
